import { useMutation } from 'react-query';

import { QUERY_KEYS } from '@24i/nxg-sdk-photon/src';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';
import { log } from '@24i/nxg-core-utils/src/logger';
import { useFirebase } from '@24i/nxg-sdk-smartott-shared/src/context/Firebase';

import { useInvalidatePurchases } from '../purchases/useIsAssetPurchasedQuery';

const useCancelSubscriptions = () => {
    const { cancelSubscription } = usePurchaseData();
    const { invalidatePurchasesQuery } = useInvalidatePurchases();

    const { recordError } = useFirebase();

    const { mutate, isLoading } = useMutation(
        QUERY_KEYS.availableSubscriptions,
        (subscriptionId: string) => cancelSubscription(subscriptionId),
        {
            onSuccess: () => {
                invalidatePurchasesQuery();
            },
            onError: (error) => {
                log(error);
                recordError?.(error);
            },
        }
    );
    return {
        mutate,
        isLoading,
    };
};

export default useCancelSubscriptions;
